import React from "react";

export default function Text(props) {
    return (
        <div {...props} style={{display: "flex", ...props.style}}>
            {props.children}
        </div>
    )
}
